import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Steper from "Component/Steper/Steper";
import Selecttokenmod from "Component/Modals/Selecttokenmod";
import { verifyEmail } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";

import { useNavigate } from "react-router-dom";
import useToastr from "helpers/toastr";
import { useTranslation } from "react-i18next";

const Verifyemail = (props) => {
  const { loading } = useSelector((state) => state?.VerifyEmail);

  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);
  const dispatch = useDispatch();
  const toastr = useToastr();
  const { t } = useTranslation();

  const [fields, setFields] = useState({
    role: "USER",
    email: "",
  });

  const handleback = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  /**
   * Used for control the states of inputs
   */
  const handleChange = (name) => (e) => {
    const inputValue = e.target.value.trim();
    setFields((prev) => ({ ...prev, [name]: inputValue }));
  };

  /**
   * Used for save the submitted email to the api
   */
  const handleVerify = (e) => {
    e.preventDefault();
    if (fields.email.trim() == "") {
      return toastr.error(t("email_required"));
    }

    const callback = (response) => {
      if (response.statusCode == "200") {
        toastr.success(response.message);
        navigate("/signin");
      } else {
        toastr.error(response.message);
      }
    };
    dispatch(verifyEmail(fields, callback));
  };

  /**
   * Used for render the UI of verify email
   */
  return (
    <Fade>
      <Selecttokenmod show={selecttoken} onHide={() => setselectoken(false)} />

      <section className="verify_mail position-relative">
        {loading && <Loader />}

        {/* <div className="top_circle"></div> */}

        <Container fluid className="position-relative container_postition">
          <Row>
            <Col lg={12} md={12} sm={12} className="m-auto">
              <div className="left_form_part common_box_wrap py-0">
                <div className="trassaction_mod_inner position-relative text-start">
                  <div className="d-flex align-items-center">
                    <a
                      href="javascript:void(0)"
                      className="arrow-back d-flex align-items-center gap-2 mb-5"
                      onClick={handleback}
                    >
                      <span className="me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 40 30"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_48_5634)">
                            <path
                              d="M3.23437 13.2344C2.25781 14.2109 2.25781 15.7969 3.23437 16.7734L15.7344 29.2734C16.7109 30.25 18.2969 30.25 19.2734 29.2734C20.25 28.2969 20.25 26.7109 19.2734 25.7344L11.0312 17.5L35 17.5C36.3828 17.5 37.5 16.3828 37.5 15C37.5 13.6172 36.3828 12.5 35 12.5L11.0312 12.5L19.2656 4.26562C20.2422 3.28906 20.2422 1.70312 19.2656 0.72656C18.2891 -0.250003 16.7031 -0.250003 15.7266 0.72656L3.22656 13.2266L3.23437 13.2344Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_48_5634">
                              <rect
                                width="30"
                                height="40"
                                fill="white"
                                transform="translate(0 30) rotate(-90)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </a>
                  </div>
                  <h2 className="m-0 sign_head">{t("forgot_password")}</h2>

                  <div className="verification_text my-3">
                    <p>{t("email_sent")}</p>
                  </div>

                  <div className="email_form-main my-4">
                    <Form className="email_form" onSubmit={handleVerify}>
                      <FormGroup>
                        <Label for="exampleEmail">
                          {t("email")}{" "}
                          <span className="col_red">
                            <sup>*</sup>
                          </span>
                        </Label>
                        <Input
                          // type="email"
                          name="email"
                          id="exampleEmail"
                          placeholder={t("email_placeholder_text")}
                          onChange={handleChange("email")}
                          title={t("fill_this_field")}
                          value={fields.email}
                        />
                      </FormGroup>

                      {/* <FormGroup check>
                        <Label check>
                          <Input type="checkbox" /> I agree with{" "}
                          <a
                            href="https://transak.com/terms-of-service"
                            target="_blank"
                          >
                            Terms of Use
                          </a>{" "}
                          and {""}
                          <a
                            href="https://transak.com/privacy-policy"
                            target="_blank"
                          >
                            Privacy Policy
                          </a>
                        </Label>
                      </FormGroup> */}
                      <Button
                        type="submit"
                        className="btn_sign_in w-100 btn_theme mt-4"
                        // onClick={handleVerify}
                      >
                        {t("continue")}
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        {/* <div className="bottom_circle"></div> */}
      </section>
    </Fade>
  );
};

export default Verifyemail;
